import { createContext } from "react";
const InsuranceDataContext = createContext({});
export default InsuranceDataContext;
